import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ChatApp = () => {
  const [conversations, setConversations] = useState([]);
  const [activeChat, setActiveChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const activeChatRef = useRef(null);

  useEffect(() => {
    activeChatRef.current = activeChat;
  }, [activeChat]);

  useEffect(() => {
    const fetchConversations = async () => {
      const res = await fetch('http://192.168.0.221:3001/conversations');
      const data = await res.json();
      setConversations(data);

      const currentActive = activeChatRef.current;
      if (currentActive) {
        const updated = data.find(conv => conv.number === currentActive.number);
        if (updated) {
          setActiveChat(updated);
        }
      } else if (data.length) {
        setActiveChat(data[0]);
      }
    };

    fetchConversations();
    const interval = setInterval(fetchConversations, 10000);
    return () => clearInterval(interval);
  }, []);

  const fetchMessages = async (number) => {
    const res = await fetch(`http://192.168.0.221:3001/messages/${number}`);
    const data = await res.json();
    setMessages(data);
  };

  useEffect(() => {
    if (!activeChat) return;
    fetchMessages(activeChat.number);

    const interval = setInterval(() => {
      fetchMessages(activeChat.number);
    }, 5000);

    return () => clearInterval(interval);
  }, [activeChat]);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const newMessage = {
      from: 'me',
      body: input,
      timestamp: new Date().toISOString()
    };

    await fetch('http://192.168.0.221:3001/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ to: activeChat.number, message: input })
    });

    setMessages(prev => [...prev, newMessage]);
    setInput('');
  };

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        {/* Lista de atendimentos */}
        <div className="col-md-3 border-end" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
          <h5>Atendimentos</h5>
          {conversations.map((conv, idx) => (
            <div
              key={idx}
              className={`p-2 border-bottom d-flex align-items-center ${activeChat?.number === conv.number ? 'bg-light' : ''}`}
              onClick={() => {
                setActiveChat(conv);
                fetchMessages(conv.number);
              }}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={conv.profilePic || 'https://via.placeholder.com/40'}
                alt="Foto"
                className="rounded-circle me-2"
                width={40}
                height={40}
              />
              <div className="flex-grow-1">
                <strong>{conv.name}</strong><br />
                <small>{conv.lastMessage || 'Sem mensagens'}</small>
              </div>
              {conv.timestamp && (
                <small className="text-muted ms-2" style={{ fontSize: '0.75rem' }}>
                  {formatDateTime(conv.timestamp)}
                </small>
              )}
            </div>
          ))}
        </div>

        {/* Tela de chat */}
        <div className="col-md-9 d-flex flex-column" style={{ height: '80vh' }}>
          <div className="flex-grow-1 overflow-auto border-bottom p-3">
            {messages.map((msg, i) => (
              <div key={i} className={`mb-2 d-flex ${msg.from === 'me' ? 'justify-content-end' : 'justify-content-start'}`}>
                <div className={`p-2 rounded ${msg.from === 'me' ? 'bg-primary text-white' : 'bg-light'}`}>
                  {msg.mediaUrl ? (
                    (() => {
                      const ext = msg.mediaUrl.split('.').pop().toLowerCase();
                      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) {
                        return <img src={msg.mediaUrl} alt="imagem" className="img-fluid rounded mb-2" style={{ maxWidth: '300px' }} />;
                      } else if (['mp3', 'ogg', 'wav'].includes(ext)) {
                        return <audio controls src={msg.mediaUrl} className="mb-2" />;
                      } else if (['mp4', 'webm', 'ogg'].includes(ext)) {
                        return <video controls src={msg.mediaUrl} className="img-fluid rounded mb-2" style={{ maxWidth: '300px' }} />;
                      } else {
                        return <a href={msg.mediaUrl} target="_blank" rel="noopener noreferrer">Arquivo</a>;
                      }
                    })()
                  ) : null}

                  <div>{msg.body}</div>
                  {msg.timestamp && (
                    <small className="text-muted d-block mt-1" style={{ fontSize: '0.75rem' }}>
                      {formatDateTime(msg.timestamp)}
                    </small>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="p-3 d-flex">
            <input
              className="form-control me-2"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && sendMessage()}
              placeholder="Digite sua mensagem..."
            />
            <button className="btn btn-success" onClick={sendMessage}>Enviar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatApp;
